import "../../../resources/less/components/Popups/SwitchToFreemiumPopup.less";
import "../../../resources/less/components/Popups/SwitchToPremiumPopup.less";
import NanoPopup from "../../components/Popups/NanoPopup";
import NanoPopupQueue from "../../components/Popups/NanoPopupQueue";
import RestPromise from "../../utils/RestPromise";
import { EPopupID } from "./EPopupID";

/**
 * One-shot "your account switched to freemium / premium" notices. The
 * backend renders their markup until the user has seen them; opening one
 * reports it back so it stops being rendered.
 */
export default class LicenceSwitchPopups {
  constructor(
    queue: {
      Add(popup: NanoPopup, priority: number): void;
    } = NanoPopupQueue.instance,
    markShown: (popupId: EPopupID) => void = (popupId) =>
      void RestPromise.Create<void>("/rest/user/me/popup-shown", "POST", {
        popupId,
      }),
  ) {
    const notices = [
      ["#switch-to-freemium-popup", EPopupID.FREEMIUM],
      ["#switch-to-premium-popup", EPopupID.PREMIUM],
    ] as const;

    for (const [target, popupId] of notices) {
      if ($(target).length > 0) {
        queue.Add(
          new NanoPopup({ target, isOpen: () => markShown(popupId) }),
          10,
        );
      }
    }
  }
}
